import { noteForIndex, triggerMomentary, type InstrumentPlayerProps } from "../playerTypes";

export function ErhuPlayer(props: InstrumentPlayerProps) {
  const shape = props.variant.soundbox?.shape ?? "hexagonal";

  return (
    <div className="instrument-ui erhu-ui" data-testid="instrument-player-erhu">
      <div className="erhu-neck" aria-hidden="true">
        <span className="erhu-string erhu-string-left" />
        <span className="erhu-string erhu-string-right" />
      </div>
      <div className="erhu-string-controls" aria-label="Erhu open-string sustain controls" data-control-target="erhu-portamento">
        {["D4", "A4"].map((noteName, index) => (
          <button
            key={noteName}
            type="button"
            className="erhu-string-control"
            aria-label={`Hold erhu ${index === 0 ? "inner D4" : "outer A4"} string`}
            onPointerDown={() =>
              props.onNoteStart({
                source: "pointer",
                noteName: noteForIndex(props.instrument.playableNotes, index === 0 ? 0 : 3),
                velocity: 0.72,
                ornament: "rou_xian"
              })
            }
            onPointerUp={() => props.onNoteEnd(noteForIndex(props.instrument.playableNotes, index === 0 ? 0 : 3))}
            onPointerCancel={() => props.onNoteEnd(noteForIndex(props.instrument.playableNotes, index === 0 ? 0 : 3))}
          >
            {noteName}
          </button>
        ))}
      </div>
      <button
        type="button"
        className="erhu-resonator"
        data-shape={shape}
        aria-label={`Play erhu with ${shape} resonator`}
        data-testid="erhu-resonator"
        onClick={() => triggerMomentary(props, "D4", "rou_xian", 0.72, 800)}
      >
        <span>python skin membrane</span>
      </button>
      <div className="instrument-control-strip">
        <label className="surface-slider" data-control-target="erhu-bow-pressure">
          <span>Bow pressure</span>
          <input aria-label="Erhu bow pressure" type="range" min="0" max="1" step="0.01" defaultValue="0.5" onInput={(event) => props.onControl("bow_pressure", Number(event.currentTarget.value))} />
        </label>
        <label className="surface-slider">
          <span>Bow speed</span>
          <input aria-label="Erhu bow speed" type="range" min="0" max="1" step="0.01" defaultValue="0.45" onInput={(event) => props.onControl("bow_speed", Number(event.currentTarget.value))} />
        </label>
        <select aria-label="Erhu portamento curve" defaultValue="smoothstep" onChange={(event) => props.onControl("erhu_portamento_shape", event.currentTarget.value)}>
          <option value="smoothstep">Smoothstep</option>
          <option value="logistic">Logistic</option>
          <option value="free_drag">Free drag</option>
        </select>
        <button type="button" aria-label="Trigger erhu portamento" onClick={() => triggerMomentary(props, "D4", "portamento", 0.76, 620)}>
          Portamento
        </button>
      </div>
      <p className="instrument-note">Rou xian is shown as contact pressure plus pitch micro-motion, not as a generic LFO.</p>
    </div>
  );
}
